import { GetProcessLayoutResponseSchema, UpdateProcessLayoutRequestSchema, UpdateProcessLayoutResponseSchema } from './process-layout.schema';
export const getProcessLayoutContract = {
    method: 'GET',
    path: '/api/v2/process/:processId/layout',
    description: 'Fetch the layout (step + synthetic node positions, swimlane order) for a process at the requested scope (draft or published)',
    responseSchema: GetProcessLayoutResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Process not found'
        }
    }
};
export const updateProcessLayoutContract = {
    method: 'PUT',
    path: '/api/v2/process/:processId/layout',
    description: 'Upsert the layout doc at the given scope, patching only the keys included in the request body',
    requestSchema: UpdateProcessLayoutRequestSchema,
    responseSchema: UpdateProcessLayoutResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid payload',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Process not found'
        }
    }
};

//# sourceMappingURL=process-layout.contract.js.map